import React,{useEffect} from 'react';
import { Row, Col } from 'antd';
import './RightFeature.css'; // Import custom CSS if needed
import Aos from 'aos';
import "aos/dist/aos.css"

export const RightFeature = React.forwardRef(({ features, animeSrc, animeQuote, animeName, imageSrc, title, description, animation, isMobile }, ref) => {
    useEffect(()=>{
        Aos.init({duration:2000})
    },[])
    return (
        <div className={`right-feature ${isMobile ? "mobile-padding" : "desktop-padding"}`} > 
            <Row className="right-feature-row" >
                <Col span={isMobile ? 24 : 9} className={`right-feature-image ${isMobile ? "mobile-feature-image" : "desktop-feature-image"}`} data-aos={animation}>
                <img src={imageSrc} alt={animeName} className="right-feature-responsive-image"/>
                </Col>
                <Col span={isMobile ? 24 : 9} data-aos="fade-right" className="right-feature-text">
                    <h1 className="right-title">{title}</h1>
                    <ul>
                        <li>
                            <p className="right-content">{features[0]}</p>
                        </li>
                        <li>
                            <p className="right-content">{features[1]}</p>
                        </li>
                        <li>
                            <p className="right-content">{features[2]}</p>
                        </li>
                        <li>
                            <p className="right-content">{features[3]}</p>
                        </li>
                    </ul>
                </Col>
                {!isMobile && 
                <Col span={6} data-aos="fade-right" className="right-feature-message">
                    <img src={animeSrc} alt="Anime_Image" className="right-feature-message-image"/>
                    <p className="message">"{animeQuote}" - {animeName}</p>
                </Col>}
            </Row>
            <div className="horizontal-line"></div>
        </div>
    );
});

